import Tools, { getRootDomain } from "utils/tools";

/** node环境  local: 本地  dev: 开发  pre: 预生产 pro: 生产 */
export const ENV = process.env.REACT_APP_ENV || "pro";

/** 项目的根路径 */
export const PUBLIC_URL = process.env.PUBLIC_URL;

/** 当前页面地址 */
// export const LOCALHOST = window.location.origin;

/** http前缀 */
const addrStart = ENV === "pro" ? "https" : "http";

/** 地址前缀 */
const addrFront = ENV === "pro" ? "" : (ENV === "test" ? "dv" : (ENV === "pre" ? "test" : "dev"));

/** 地址后缀 */
const addrEnd = (ENV === "dev" || ENV === "local") ? ":8088" : "";

export const DOMAIN =  getRootDomain() || "viphrm.com";

/** 登录地址 */
export const LOGIN_URL = `${addrStart}://${addrFront}login.${DOMAIN}${addrEnd}`;

/** moss地址 */
export const mossAddr = `${addrStart}://${ENV === "pro" ? "" : (ENV === "local" || ENV === "dev" ? "dev" : ENV)}moss.${DOMAIN}`;

/** home地址 */
export const homeAddr = `${addrStart}://${ENV === "pro" ? "" : (ENV === "local" || ENV === "dev" ? "dev" : ENV)}home.${DOMAIN}`;

/** 错误信息 */
export const ERROR_MESSAGE = "系统维护中，请联系管理员。";

/** 加载信息 */
export const LOADING_MESSAGE = "正在查询，请稍后...";

/** 1兆 */
export const ONE_M = 1048576;

/** 外链地址中的来源应用编码 */
export const SOURCE_APPCODE = Tools.getUrlParam("sourceAppCode") || "";

export const MOBILE_CLASS = Tools.mobileCheck() ? "mobile" : "";

export const LOCALHOST = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;

export const YUNPIN_LOCALHOST = ENV === "local" ? "http://localhost:20001" : ENV === "dev" ? `http://devhrtrading.${DOMAIN}` : ENV === "pre" ? "https://prexmy.xiangmayun.cn" : "https://xiangmayun.cn"

export const IMAGE_CODE_URL = `${ENV === "local" ? `https://pre.s.login.${DOMAIN}` : ENV === "dev" ? "http://192.168.2.118:8409" : (ENV === "test" ? "http://192.168.2.118:8409" : (ENV === "pre" ? `https://pre.s.login.${DOMAIN}` : `https://s.login.${DOMAIN}`))}`;
/** 初始化分页 */
export const INIT_PAGINATION = {
  pageSize: 25,
  current: 1,
  total: 0,
  totalPages: 0
};

export const appId = "13001";

export const moaConfig = ENV === "pro" ? {
  baseUrl: `https://s.login.${DOMAIN}`,
  loginUrl: `http://moa.${DOMAIN}/#!/`,
  moaUrl: `http://moa.${DOMAIN}`,
  paltformUrl: `http://inlet.${DOMAIN}`,
  supplierUrl: `http://supplier-web.${DOMAIN}`,
  registerUrl: `https://register.${DOMAIN}`,
  wdpUrl: `http://news.${DOMAIN}`,
  mossUrl: `http://moss.${DOMAIN}`,
  homeUrl: `http://home.${DOMAIN}`,
  newImageCodeUrl: `https://moss.${DOMAIN}`,
  smartHRUrl: "https://home.smarthr.cn",
  mossrecruitUrl: `https://mossrecruit.${DOMAIN}`,
}:
{
  baseUrl: `https://pre.s.login.${DOMAIN}`,
  loginUrl: `http://testmoa.${DOMAIN}/#!/`,
  moaUrl: `http://testmoa.${DOMAIN}`,
  paltformUrl: `http://inlet.${DOMAIN}`,
  supplierUrl: `http://presupplier-web.${DOMAIN}`,
  registerUrl: `${window.location.protocol}//preregister.${DOMAIN}`,
  wdpUrl: `${window.location.protocol}//news.${DOMAIN}`,
  mossUrl: `${window.location.protocol}//premoss.${DOMAIN}`,
  homeUrl: `${window.location.protocol}//prehome.${DOMAIN}`,
  newImageCodeUrl: `https://premoss.${DOMAIN}`,
  smartHRUrl: "https://prehome.smarthr.cn",
  mossrecruitUrl: `https://prerecruit.${DOMAIN}`,
};

export const password_rule = "密码为8-20位数字，字母及特殊字符的组合，且不能包含连续数字";

/**密码不可包含字符串 */
export const continuedChar = "qaz,wsx,asd,zxc,qwe,edc,123,1234,12345,123456,1234567,12345678,123456789,1234567890,666,888,111,000";

/** 纯色页面logo */
export const LOGO_PAGE_PLAIN = "https://cs-common.oss-cn-hangzhou.aliyuncs.com/e_page_logo_plain@2x.png"
